"use server";

import { AuthError } from "next-auth";
import { signIn } from "@/auth";
import { checkRateLimit, getClientIp } from "@/lib/rate-limit";

// Only ever redirect to a relative, same-site path - never trust the raw
// callbackUrl as-is, or a crafted "//evil.com" / "/\evil.com" value could
// send a just-logged-in user off-site (open redirect).
function safeCallbackUrl(callbackUrl: string | null | undefined): string {
  if (
    callbackUrl &&
    callbackUrl.startsWith("/") &&
    !callbackUrl.startsWith("//") &&
    !callbackUrl.startsWith("/\\")
  ) {
    return callbackUrl;
  }
  return "/account";
}

export async function login(
  callbackUrl: string | null,
  _prevState: string | undefined,
  formData: FormData,
) {
  const ip = await getClientIp();
  if (!checkRateLimit(`login:${ip}`, 10, 5 * 60 * 1000)) {
    return "Zbyt wiele prób logowania. Spróbuj ponownie za kilka minut.";
  }

  try {
    await signIn("credentials", {
      email: formData.get("email"),
      password: formData.get("password"),
      redirectTo: safeCallbackUrl(callbackUrl),
    });
  } catch (error) {
    if (error instanceof AuthError) {
      return "Nieprawidłowy email lub hasło.";
    }
    throw error;
  }
}
